module.exports = __webpack_public_path__ + "static/media/login-v4.c80bde81.jpg";